const ORIGIN_PATTERNS = {
  POS: [
    /www.alegra.com\/((.)+\/)?pos/,
    /www.alegra.com\/((.)+\/)?tpv/,
    /www.alegra.com\/((.)+\/)?punto-venta/,
  ],
  POS_BOUTIQUES: /www.alegra.com\/((.)+\/)?pos\/boutiques/,
  RESICO: /^(?=.*\balegra\b)(?=.*\bresico\b).*$/,
  POS_WOMPI_COLOMBIA:
    /^(?=.*\balegra\b)(?=.*\bcolombia\b)(?=.*\bpos\b)(?=.*\balianza\b)(?=.*\bwompi\b).*$/,
  FACTURACION: /^(?=.*\balegra\b)(?=.*\bfacturacion\/?$).*$/,
  SOLO_FE: /facturacion-electronica.com.co\/((.)+\/)?/,
  FE: /^(?=.*\balegra\b)(?=.*\bfacturacion-electronica\b).*$/,

  ALEGRA_CONTADORES: /^(?=.*\balegra\b)(?=.*\bcontadores\/?$).*$/,
  ALEGRA_CONTADOR: /^(?=.*\balegra\b)(?=.*\bcontador\/?$).*$/,
  ALEGRA_MIGRATION: /^(?=.*\balegra\b)(?=.*\bcolombia\b)(?=.*\bcontabilidad\b)(?=.*\bmigracion\b).*$/,
  SECTOR_SALUD: /^(?=.*\balegra\b)(?=.*\bsector-salud\b).*$/,
  NOMINA: /www.alegra.com\/((.)+\/)?nomina(-electronica)?/,
} as const

export { ORIGIN_PATTERNS }
